import React from "react";
import { observer } from "mobx-react-lite";
import { communitiesStore } from "communities/_stores/communitiesStore";
import { useCommunitiesPageContext } from "communities/communities-listing/communities-view-context";
import { useCommunitiesPageMeta } from "communities/communities-listing/hooks/use-communities-page-meta";
import { Meta } from "_common/_utils/Meta";
import { URLS } from "_configs/URLS";
import { NoResults } from "pages/NoResults";
import { CommunitiesCount } from "communities/communities-listing/_components/communities-count";
import clsx from "clsx";
import { PROPERTY_VIEW_STYLE } from "properties/components/BREAKPOINTS_SECTION_CARDS";
import { LoadableFromLoading } from "_common/loaders/LoadableFromLoading";
import { ListLoader } from "properties/ListLoader";
import { CommunitiesViewListItems } from "communities/communities-listing/_components/communities-view-list-items";
import { CommunitiesViewPagination } from "communities/communities-listing/_components/communities-view-pagination";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import { CommunitiesBreadcrumb } from "communities/communities-listing/_components/communities-breadcrumb";

export const CommunitiesViewList = observer(() => {
    const listStore = communitiesStore.getListStore("communities");
    const { mapOrListSelected } = useCommunitiesPageContext();
    const { title, metaTitle, metaDescription } = useCommunitiesPageMeta();

    return (
        <>
            <Meta title={metaTitle} description={metaDescription} url={URLS.communities()} />
            <h1 className={"text-xl"}>{title}</h1>
            <div className="flex flex-col md:flex-row md:justify-end my-5">
                <CommunitiesCount />
            </div>
            {listStore.count === 0 && <NoResults />}
            <div
                className={clsx("grid grid-cols-1 gap-4", {
                    ["md:grid-cols-2 lg:grid-cols-3"]: mapOrListSelected === PROPERTY_VIEW_STYLE.LIST,
                    ["xl:grid-cols-2"]: mapOrListSelected === PROPERTY_VIEW_STYLE.MAP,
                })}
            >
                <LoadableFromLoading
                    loading={listStore.currentLoadingState}
                    contentRender={<ListLoader />}
                    renderer={() => {
                        return <CommunitiesViewListItems />;
                    }}
                />
            </div>
            <CommunitiesViewPagination />
            {!!geoZonesStore?.geoZone && (
                <div className={"flex items-center justify-center py-4"}>
                    <CommunitiesBreadcrumb />
                </div>
            )}
        </>
    );
});
